import { render, staticRenderFns } from "./RenewalPaymentSummary.vue?vue&type=template&id=b2ffcbf8&scoped=true"
import script from "./RenewalPaymentSummary.vue?vue&type=script&lang=js"
export * from "./RenewalPaymentSummary.vue?vue&type=script&lang=js"
import style0 from "./RenewalPaymentSummary.vue?vue&type=style&index=0&id=b2ffcbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ffcbf8",
  null
  
)

export default component.exports